module.exports = __webpack_public_path__ + "img/15_4.da787a8d.png";